<template>
  <div id="id-article-box">
    <div
      class="wrapper"
      v-html="articleData"
    ></div>
  </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
  data () {
    return {
      articleData: null
    }
  },
  computed: {
    ...mapState({
      articleContents: (state) => state.article.articleContents
    })
  },
  mounted () {
    this.querySectionItemRichText(this.$route.query.id)
  },
  methods: {
    querySectionItemRichText (id) {
      this.axios.get('/api/sectionItem/querySectionItemRichText/' + id)
        .then(({data: resData}) => {
          this.articleData = this.escape2Html(resData.data)
        })
    },
    escape2Html (data) {
      let str = JSON.stringify(data)
      let arrEntities = { lt: '<', gt: '>', nbsp: ' ', amp: '&', quot: '\\"', '#39': '\'', ldquo: '“', rdquo: '”', middot: '·' }
      data = str.replace(/&(lt|gt|nbsp|amp|quot|#39|ldquo|rdquo|middot);/ig, function (all, t) { return arrEntities[t] })
      return JSON.parse(data)
    }
  }
}
</script>
<style
  lang="scss"
  scoped
>
#id-article-box {
  & .wrapper {
    -webkit-user-select: text;
    -moz-user-select: text;
    -ms-user-select: text;
    user-select: text;
  }

  .wrapper {
    white-space: pre-wrap;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/ui/ArticleShow.vue